import { render, staticRenderFns } from "./FilterYear.vue?vue&type=template&id=640d7e6c&"
import script from "./FilterYear.vue?vue&type=script&lang=js&"
export * from "./FilterYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports